module.exports = __webpack_public_path__ + "static/img/product_banner_27_zh.4110618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_27_zh.png
// module id = 1a+H
// module chunks = 34